export default "__VITE_ASSET__vctN1KAF__"